import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import { Box, Spinner, Text, useBreakpoint } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useGetProductUpdates } from 'modules/product_updates/hooks/useGetProductUpdates'
import { ProductUpdate } from 'modules/product_updates/types'

import { Item } from './_Item'

type Props = {
  productUpdate?: ProductUpdate
}

export const ModuleRelatedUpdatesCard = ({ productUpdate }: Props) => {
  const { productUpdates: relatedUpdates, loading } = useGetProductUpdates({
    alreadyReleased: true,
    moduleIdentifier: productUpdate?.productModule.urlIdentifier,
  })
  const { pathname } = useLocation()
  const { isMobile } = useBreakpoint()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (!relatedUpdates?.length && !loading) return null

  const filteredUpdates = relatedUpdates
    .filter((update) => update.id !== productUpdate?.id)
    .slice(0, 4)

  return (
    <Box
      flexDirection="column"
      gap="s12"
      borderRadius={{
        all: 'abs016',
      }}
      minHeight="s200"
      minWidth="s400"
      paddingTop={isMobile ? 's16' : 's0'}
      paddingX={isMobile ? 's0' : 's12'}
    >
      <Box gap="s12">
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text size="200" weight="semibold" color="black">
            {i18n.t('product_updates.detail_page.latest_from', {
              module: productUpdate?.productModule.name,
            })}
          </Text>
          <F0Button
            size="sm"
            variant="outline"
            label={i18n.t('product_updates.detail_page.view_all')}
            onClick={() => {
              track(trackingEvents.productUpdates.goToProductUpdatesPage, {
                source: 'product_details_latest_updates',
                origin: pathname,
              })
              navigate(
                navigation.discover.productUpdates.fullPath() +
                  `?module=${productUpdate?.productModule.urlIdentifier}#module-filters`
              )
            }}
          />
        </Box>
        {loading ? (
          <Box alignItems="center" justifyContent="center" height="s200">
            <Spinner />
          </Box>
        ) : (
          <Box gap="s16" paddingTop="s8">
            {filteredUpdates.map((module) => (
              <Item
                key={module.id}
                // eslint-disable-next-line no-type-assertion/no-type-assertion
                module={module as ProductUpdate}
                onClick={() => {
                  track(trackingEvents.productUpdates.goToProductUpdatesDetailPage, {
                    source: 'product_details_latest_updates',
                    origin: module.slug,
                  })
                  navigate(navigation.discover.productUpdates.item.fullPath({ slug: module.slug }))
                }}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  )
}
